import React, { useCallback, useEffect, useMemo, useState } from 'react';
import debounce from 'lodash/debounce';
import { DefaultItemHeight } from '../SlideItem';
import './index.scss';
const SlideList = ({ children, heights: propsHeights, onSelect, trigger, selected }) => {
    const [top, setTop] = useState(0);
    if (!Array.isArray(children)) {
        return React.createElement(React.Fragment, null);
    }
    const heights = useMemo(() => ((propsHeights === null || propsHeights === void 0 ? void 0 : propsHeights.length) ? propsHeights : new Array(children.length).fill(DefaultItemHeight)), []);
    const tops = useMemo(() => heights.reduce((res, curr, currIndex) => {
        var _a;
        const currHeight = curr !== null && curr !== void 0 ? curr : DefaultItemHeight;
        const prevHeight = (_a = res[currIndex]) !== null && _a !== void 0 ? _a : 0;
        res.push(currHeight + prevHeight);
        return res;
    }, [0]), []);
    const debounceOnSelect = useCallback(debounce((index) => {
        onSelect(index);
    }, 300), []);
    const onTrigger = (index, method) => {
        if (!trigger || trigger === method) {
            setTop(tops[index]);
            debounceOnSelect(index);
        }
    };
    const bgBlockStyle = useMemo(() => ({
        top,
        height: heights[selected],
    }), [top, heights, selected]);
    useEffect(() => {
        setTop(tops[selected]);
    }, [selected, tops]);
    return (React.createElement("div", { className: "slide-list-container" },
        children.map((child, index) => (React.createElement("div", { className: "slide-list-item", key: index, onClick: () => onTrigger(index, 'click'), onMouseEnter: () => onTrigger(index, 'hover') }, child))),
        React.createElement("div", { className: "slide-list-bg-block", style: bgBlockStyle })));
};
export default SlideList;
